import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and merges Tailwind classes using tailwind-merge.
 * This ensures that conflicting Tailwind classes are properly resolved.
 *
 * @example
 * cn('bg-red-500', 'bg-blue-500') // => 'bg-blue-500' (blue wins)
 * cn('px-2 py-1', 'p-3') // => 'p-3' (p-3 wins)
 * cn('text-sm', isActive && 'text-lg') // => 'text-lg' if isActive is true
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
